import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DidService } from '../../../services/did/did.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { PeersService } from '../../../services/peers/peers.service';
import { UserService } from '../../../services/user/user.service';
import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../../toast/toast.component';
import { LocalStorage } from '@ngx-pwa/local-storage';


export interface DialogData {
    animal: string;
    name: string;
}

@Component({
    selector: 'app-add-dids',
    templateUrl: './add-dids.component.html',
    styleUrls: ['./add-dids.component.scss']
})
export class AddDidsComponent implements OnInit {

    formAddDid = new FormGroup({
        myControl: new FormControl(''),
        redirect: new FormControl('peer'),
        peer: new FormControl('')
    });
    
    options: any[] = [];
    filteredOptions: Observable<string[]>;

    public direcionamento = 'peer';
    public loading = true;
    public peers = [];
    public usersCrm = [];
    public peer;

    constructor(
        public dialogRef: MatDialogRef<AddDidsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public didService: DidService,
        public peersService: PeersService,
        public userService: UserService,
        private snackBar: MatSnackBar,
        public localStorage: LocalStorage
    ) { }

    ngOnInit() {
        this.didService.stock().subscribe((res) => {
            this.options = res.dids;
            this.getLabels(() => {
                this._order(() => {
                    this.listPeers(() => {
                        this.listUsersCrm(() => {
                            this.getUserRamal();
                        })
                    });
                });
            });
            this.filteredOptions = this.formAddDid.controls.myControl.valueChanges
                .pipe(
                    startWith(''),
                    map(value => typeof value === 'string' ? value : value.cidade),
                    map(cidade => cidade ? this._filter(cidade) : this.options.slice())
                );
            this.loading = false;
        })
    }

    displayFn = (did) => {
        return did ? did.label : undefined;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    private _filter(nome: string) {
        const filterValue = nome.toLowerCase();
        var teste = this.options.filter((option: any) => {
            return option.cidade.toLowerCase().includes(filterValue) == true
        });
        return teste;
    }

    getLabels(callback) {
        this.options.forEach((item: any) => {
            item.label = "(" + item.estado + ") " + item.cidade + " - " + item.numero;
        })

        callback();
    }

    _order(callback) {
        for (let i = 0; i < this.options.length - 1; i++) {
            for (let j = i + 1; j < this.options.length; j++) {
                if (this.options[j].label < this.options[i].label) {
                    let auxItem = this.options[i];
                    this.options[i] = this.options[j];
                    this.options[j] = auxItem;
                }
            }
        }

        callback();
    }

    listPeers(callback) {
        this.peersService.list().subscribe((res) => {
            this.peers = res.peers;

            callback();
        })
    }

    listUsersCrm(callback) {
        this.userService.listUsersCrm().subscribe((res) => {
            this.usersCrm = res.data;
            callback();
        })

    }
    
    getUserRamal() {
        this.peers.forEach((peer) => {
            this.usersCrm.forEach((user) => {
                if (peer.user_crm_id == user.id) {
                    peer.label = peer.peer_number + " - " + user.nome;
                }
            })
        })
    }

    save() {
        let didId = this.formAddDid.controls.myControl.value.id;
        let redirect = this.formAddDid.value.redirect;
        let redirect_id = this.formAddDid.value.peer
        this.loading = true;
        this.didService.add(didId, redirect, redirect_id).subscribe((res)=>{
            this.snackBar.openFromComponent(ToastComponent, {
                data: res.msg,
                duration: 5000
            });
            this.loading = false;
            if(res.success){
                this.dialogRef.close();
            }
        })
    }

    openChat() {
        this.localStorage.getItem('user').subscribe((item:any) => {
            octadesk.chat.login({ 
                name: item.name, 
                email: item.email 
            }); 
    
            octadesk.chat.showApp();
        })
    }
}
